export enum PhaseEnum {
    None = 0
}

export const PhaseEnumDescriptions: Record<PhaseEnum, string> = {
    [PhaseEnum.None]: 'None'
};